function Actions() {
	return <div id="working-shifts-drawer" />;
}

export default Actions;
